import { ISimpleTableCellRenderProps } from "@asup/simple-table";
import { ITlfItemRelationship } from "functions/api/tlfItem/TlfItemIndexReadDto";
import { eHierarchyLevel, eLinkType } from "../../../functions/api/enums";
import { TlfItemTableLinkCell } from "./TlfItemTableLinkCell";

/**
 * Table cell renderer that displays the HasVersion relationships
 * for a TLF item as a sorted, comma-separated list of navigation links,
 * each linking to the corresponding template in TLF Designer.
 *
 * @param props - The component props
 * @param props.rowData - Row data containing the TLF item's relationships array
 */
export const TlfItemTaVersionsLinks = (props: ISimpleTableCellRenderProps) => {
  const links = (props.rowData["relationships"] as ITlfItemRelationship[] | undefined)
    ?.filter(
      (r) =>
        r.linkType === eLinkType.HasVersion && r.linkLocation?.linkLevel === eHierarchyLevel.TA,
    )
    .sort((a, b) => `${a.azsolId}/${a.version}`.localeCompare(`${b.azsolId}/${b.version}`));

  return links && links.length > 0 ? (
    <span className="d-inline-flex flex-wrap align-items-center">
      {links.map((link, index) => (
        <span
          key={link.linkId}
          className="d-inline-flex align-items-center"
        >
          {index > 0 && ", "}
          <TlfItemTableLinkCell
            {...props}
            rowData={{
              ...link,
              id: `${props.rowData.id}-${link.linkId}`,
              primaryHierarchyLevel: link.linkLocation?.linkLevel,
            }}
          />
        </span>
      ))}
    </span>
  ) : (
    <></>
  );
};

TlfItemTaVersionsLinks.displayName = "TlfItemVersionsLinks";
